import { TrackingRequest } from '@/services/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { PointInfo, TrackingBaseData, TrackingState } from './types';

export const initialState: TrackingState = {
  trackingInfo: {
    trackingNumber: null,
    title: null,
    tracking: [],
    statusTransaction: 0,
    pickitNumber: '',
    retailerName: '',
    transaction: null,
  },
  pickitCode: '',
  token: null,
  isDirty: false,
};

const sliceName = 'tracking';

export const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getTrackingRequest: (state, action: PayloadAction<TrackingRequest>) => {},
    getTrackingError: () => {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getTrackingSuccess: (state, action: PayloadAction<TrackingBaseData>) => {
      state.trackingInfo = action.payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPointInfoRequest: (state, action: PayloadAction<number>) => {},
    getPointInfoError: () => {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPointInfoSuccess: (state, action: PayloadAction<PointInfo>) => {
      state.pointInfo = action.payload;
    },
    setPickitCode: (state, action: PayloadAction<string>) => {
      state.pickitCode = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setIsDirty: (state, action: PayloadAction<boolean>) => {
      state.isDirty = action.payload;
    },
  },
  extraReducers: {},
});

export const { actions: actionsTracking } = slice;

export const trackingSelector = (state: RootState) => state.tracking;

export default slice.reducer;
